function titleOnlyQuery(query) {
  const trimmedQuery = query.trim();

  if (!trimmedQuery || trimmedQuery.includes('title:')) {
    return trimmedQuery;
  }

  return trimmedQuery
    .split(/\s+/)
    .filter(Boolean)
    .map((term) => `title:${term}`)
    .join(' ');
}


// Handle normal search submission / pressing Enter
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const action = new URL(form.action, window.location.origin);

    // Supports /search and localized paths like /en/search
    if (!action.pathname.endsWith('/search')) {
      return;
    }

    const searchInput = form.querySelector('input[name="q"]');

    if (!searchInput) {
      return;
    }

    searchInput.value = titleOnlyQuery(searchInput.value);
  },
  true
);


// Handle predictive search query suggestion clicks
document.addEventListener(
  'click',
  (event) => {
    const link = event.target.closest('a[href]');

    if (!link) {
      return;
    }

    const url = new URL(link.href, window.location.origin);

    // Only modify links that go to the search page.
    // Product links like /products/fina-abaya are untouched.
    if (!url.pathname.endsWith('/search')) {
      return;
    }

    const query = url.searchParams.get('q');

    if (!query) {
      return;
    }

    url.searchParams.set('q', titleOnlyQuery(query));

    // Preserve Shopify's other query parameters,
    // such as _pos, _psq, _ss, etc.
    link.href = url.toString();
  },
  true
);